import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import SelectContainer from "./SelectContainer";
import Select from "./Select";
import SelectArrow from "./SelectArrow";
var propTypes = {
  /** application theme */
  theme: PropTypes.shape({
    formSelect: PropTypes.oneOf(['dark'])
  }),
  error: PropTypes.bool
};
var defaultProps = {
  theme: {}
};
export var FormSelect = React.forwardRef(function (_ref, ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(SelectContainer, null, React.createElement(Select, Object.assign({
    ref: ref
  }, props)), React.createElement(SelectArrow, null)));
});
FormSelect.darkTheme = {
  formSelect: 'dark'
};
FormSelect.propTypes = propTypes;
FormSelect.defaultProps = defaultProps;
FormSelect.displayName = 'FormSelect';
export default FormSelect;